import {
  FAILED,
  PENDING,
  SUCCEEDED,
} from '../../../../../../../types/loadingStatus'
import { useContext } from 'react'
import { OutreachButton } from '../../../../../..'
import { defineMessages, useIntl } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import { ButtonGroup } from '@homebot/shared-ui-swashbuckle'
import useViewport from '../../../../../../../hooks/useViewport'
import { QUESTIONS } from '../../../../../../../constants/messages'
import { PmiLearnMoreButton } from '../../../../PmiLearnMoreButton'
import { AmplitudeContext } from '@homebot/shared-util-quartermaster'
import { OUTREACH_BUTTON } from '../../../../../../../constants/messages'
import { sendPmiRemovalDMRequest } from '../../../../../../../store/slices/pmi'
import { selectPmiDMRequestedStatus } from '../../../../../../../store/slices/pmi'

import styles from './CanRemovePmiDetailsFooter.module.scss'

export const MSG = defineMessages({
  ask: {
    id: 'Pmi.pmiCtaButtonSection.askAboutPMIRemoval',
    defaultMessage: 'Ask about removal',
  },
})

export const CanRemovePmiDetailsFooter = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const { isMediumOrAbove } = useViewport()
  const { ampli } = useContext(AmplitudeContext)
  const requestStatus = useSelector(selectPmiDMRequestedStatus)

  const handleClick = () => {
    ampli?.pmiRemoved()
    const message = intl.formatMessage(QUESTIONS.mortgageInsuranceFooter)
    const topic = intl.formatMessage(QUESTIONS.mortgageInsuranceTopic)
    dispatch(sendPmiRemovalDMRequest({ message, topic, ampli }))
  }

  return (
    <ButtonGroup
      gap='.25rem'
      width='100%'
      display='flex'
      orientation={isMediumOrAbove ? 'horizontal' : 'vertical'}
    >
      <OutreachButton
        buttonMessage={MSG.ask}
        handleClick={handleClick}
        className={styles.outreach}
        colorScheme='btn-primary'
        failure={requestStatus === FAILED}
        requested={requestStatus === PENDING}
        success={requestStatus === SUCCEEDED}
        resultMessage={
          requestStatus === SUCCEEDED
            ? intl.formatMessage(OUTREACH_BUTTON.success)
            : intl.formatMessage(OUTREACH_BUTTON.failure)
        }
      />
      <PmiLearnMoreButton flex='1 1 auto' />
    </ButtonGroup>
  )
}
